import { render, staticRenderFns } from "./ListDepositComponent.vue?vue&type=template&id=ddbf9166&scoped=true&"
import script from "./ListDepositComponent.vue?vue&type=script&lang=js&"
export * from "./ListDepositComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListDepositComponent.vue?vue&type=style&index=0&id=ddbf9166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbf9166",
  null
  
)

export default component.exports